// extracted by mini-css-extract-plugin
export var logosContainer = "mobWorksFooter-module--logosContainer--3wYXg";
export var footerCarLogos = "mobWorksFooter-module--footerCarLogos--1FdRG";
export var footerMosLogos = "mobWorksFooter-module--footerMosLogos--2_-S2";